<template>
  <div
    v-show="visible"
    class="plv-ia-qa-emotions pws-pc-chat-input-panel-bg-color pws-tools-scroll-color pws-que-pc-emotions pws-iar-pc-qa-ask-emotion-popper"
    @click.stop="handleAdd"
  >
    <div ref="emotionsPanel" class="plv-ia-qa-emotions__wrap pws-que-emoji-color"></div>
  </div>
</template>

<script>
import { emotionsReady } from '@polyv/emotion-sdk';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    emotionsReady(parser => {
      this.$refs.emotionsPanel.appendChild(parser.genDOMList({
        cssClass: {
          item: 'plv-ia-qa-emotions__item',
          inner: 'plv-ia-qa-emotions__item__inner'
        }
      }));
    });
  },

  methods: {
    handleAdd(e) {
      const domTarget = e.target;
      const emotionTitle = domTarget.getAttribute('data-title');
      if (!emotionTitle) {
        return;
      }
      this.$emit('add', emotionTitle);
    }
  }
};
</script>
